import React, { Component } from 'react';
import mapSurveyResponses from '../../../helpers/mapSurveyQuestions';
import Loading from '../../UI/Loading/Loading';

class RedirectInstant extends Component {
    
    state = { 
        submitting: false
    }

    componentDidMount() {
        this.performRedirect();
    }

    performRedirect = async () => {
        const { questionId, placeholder } = this.props.data;
        
        await this.props.handleChange(questionId, "Auto-Redirected");
        
        let redirectUrl = mapSurveyResponses(placeholder, this.props.fullSurvey);
        
        // Ensure URL has protocol
        if (!redirectUrl.startsWith('http://') && !redirectUrl.startsWith('https://')) {
            redirectUrl = 'https://' + redirectUrl;
        }
        
        window.location.href = redirectUrl;

        if (!this.props.lastQuestion) {
            setTimeout(() => {
                this.props.nextStep(false);
            }, 150);
        }
    }
    
    render() { 
        return ( 
            <div>
                <Loading />
            </div>
        );
    }
}
 
export default RedirectInstant;